module.exports = __webpack_public_path__ + "684494d8dfcecb34e4748f080d6aefa3.svg";